import React from 'react';
import { useSelector } from 'react-redux';
import { HeartStraight } from 'phosphor-react';
import { selectWishListQuantity } from '../Selectors/wishlist-selectors';

export default function FavouriteIcon() {

    const quantity = useSelector(selectWishListQuantity)

    return (
        <span className="cart__link--block">
            <span className="cart__icon-wrapper">
                <HeartStraight size={24} weight="regular" />
                {quantity > 0 && <span className="cart__quantity">{quantity}</span>}
            </span>
            <span className="cart__title">Favoriter</span>
        </span>
    )
}